<template>
  <div class="home">
    <div class="title">在线报名</div>
    <div class="admin-enter">
      <van-button to="/login" plain hairline type="primary" size="mini"
      >管理员入口
      </van-button>
    </div>
    <img alt="logo" height="80" src="../assets/LogoImage.png"/>
    <!--    <div class="warnTitle">报名后无法退费！</div>-->
    <van-divider
        :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 60px' }"
    />

    <van-form validate-first @submit="onSubmit" @failed="onFailed">
      <van-field
          readonly
          clickable
          required
          name="speciesID"
          label="证件种类"
          colon
          v-model="speciesName"
          placeholder="不可为空"
          @click="speciesIDPickShow = true"
          :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model:show="speciesIDPickShow" round position="bottom">
        <van-picker
            class="picker"
            :columns="speciesIDData"
            item-height="55"
            @cancel="speciesIDPickShow = false"
            @confirm="onSpeciesIDSelect"
            value-key="name"
        />
      </van-popup>

      <van-field
          readonly
          clickable
          required
          name="projectId"
          label="作业类别"
          colon
          v-model="projectName"
          placeholder="不可为空"
          @click="projectIDPickShow = true"
          :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model:show="projectIDPickShow" round position="bottom">
        <van-picker
            :columns="projectIDData"
            @cancel="projectIDPickShow = false"
            @confirm="onProjectIDSelect"
            value-key="name"
        />
      </van-popup>

      <van-field
          readonly
          clickable
          required
          name="courseID"
          label="准操项目"
          colon
          v-model="courseName"
          placeholder="不可为空"
          @click="courseIDPickShow = true"
          :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model:show="courseIDPickShow" round position="bottom">
        <van-picker
            :columns="courseIDData"
            @cancel="courseIDPickShow = false"
            @confirm="onCourseIDSelect"
            value-key="name"
        />
      </van-popup>

      <van-field name="lTChoose" label="">
        <template #input>
          <van-radio-group v-model="chooseType" direction="horizontal">
            <van-radio name="新办">新办</van-radio>
            <van-radio name="复训">复训</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
          v-model="money"
          name="name"
          label="费用"
          required
          placeholder="不可为空"
          readonly
      />

      <van-field name="sex" label="性别" required>
        <template #input>
          <van-radio-group v-model="sex" direction="horizontal">
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
          readonly
          clickable
          required
          name="education"
          label="学历"
          colon
          v-model="education"
          placeholder="不可为空"
          @click="educationPickShow = true"
          :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model:show="educationPickShow" round position="bottom">
        <van-picker
            :columns="educationData"
            @cancel="educationPickShow = false"
            @confirm="onEducationSelect"
        />
      </van-popup>

      <van-field
          v-model="name"
          name="name"
          label="姓名"
          required
          placeholder="不可为空"
          :rules="[{ required: true, message: '' }]"
      />

      <van-field
          v-model="dept"
          name="dept"
          label="单位"
          placeholder="输入单位"
      />

      <van-field
          v-model="phone"
          name="phone"
          label="手机(微信同号)"
          type="tel"
          required
          placeholder="不可为空"
          :rules="[{ required: true,pattern:patternTel, message: '请输入正确的手机号' }]"
      />

      <van-field
          v-model="cardNumber"
          name="cardNumber"
          label="身份证号"
          required
          placeholder="不可为空"
          :rules="[{ required: true,pattern:patternCard, message: '请输入正确的身份证号码' }]"
      />

      <van-field
          name="card"
          required
          label="身份证"
          :rules="[{ validator: cardValidator, message: '必须上传身份证正反面' }]"
      >
        <template #input>
          <van-uploader
              v-model="cardPositive"
              :after-read="afterRead"
              :max-count="1"
              :max-size="5000 * 1024"
              @oversize="onOversize"
          >
            <div class="card-custom-upload">
              <van-icon size="20" name="add-o"/>
            </div>
            <div class="card-custom-upload-title">正面</div>
          </van-uploader>
          <van-uploader
              v-model="cardNegative"
              :after-read="afterRead"
              :max-count="1"
              :max-size="5000 * 1024"
              @oversize="onOversize"
          >
            <div class="card-custom-upload">
              <van-icon size="20" name="add-o"/>
            </div>
            <div class="card-custom-upload-title">反面</div>
          </van-uploader>
        </template>
      </van-field>

      <van-field
          name="retrain"
          v-if="chooseType === '复训'"
          required
          label="复训证(复审证件到期前60天报名)"
          :rules="[{ validator: retrainValidator, message: '必须上传复训证正反面' }]"
      >
        <template #input>
          <van-uploader
              v-model="retrainPositive"
              :after-read="afterRead"
              :max-count="1"
              :max-size="5000 * 1024"
              @oversize="onOversize"
          >
            <div class="card-custom-upload">
              <van-icon size="20" name="add-o"/>
            </div>
            <div class="card-custom-upload-title">正面</div>
          </van-uploader>
          <van-uploader
              v-model="retrainNegative"
              :after-read="afterRead"
              :max-count="1"
              :max-size="5000 * 1024"
              @oversize="onOversize"
          >
            <div class="card-custom-upload">
              <van-icon size="20" name="add-o"/>
            </div>
            <div class="card-custom-upload-title">反面</div>
          </van-uploader>
        </template>
      </van-field>

      <van-field
          name="poq"
          required
          label="学历证明照片(初中以上)"
          :rules="[{ validator: poqValidator, message: '请上传学历证明照片' }]"
      >
        <template #input>
          <van-uploader
              v-model="poq"
              :after-read="afterRead"
              :max-count="1"
              :max-size="5000 * 1024"
              @oversize="onOversize"
          >
            <div class="card-custom-upload">
              <van-icon size="20" name="add-o"/>
            </div>
          </van-uploader>
        </template>
      </van-field>

      <van-field
          name="healthBook"
          required
          label="电子证件照(本人照片)"
          :rules="[
          { validator: healthBookValidator, message: '请上传电子证件照' }
        ]"
      >
        <template #input>
          <van-uploader
              v-model="healthBook"
              :after-read="afterRead"
              :max-count="1"
              :max-size="5000 * 1024"
              @oversize="onOversize"
          >
            <div class="card-custom-upload">
              <van-icon size="20" name="add-o"/>
            </div>
          </van-uploader>
        </template>
      </van-field>

      <div class="down-healthBook">
        <span style="font-size: 13px; color: red;margin-bottom: 5px"
        >红色 * 号为必填项，请填写完毕再进行提交</span
        >
        <span style="font-size: 13px; color: red;">
          联系电话:17756190485
        </span>
        <span @click="readNeed"
              style="font-size: 13px;margin-top: 10px;color: cornflowerblue;cursor: pointer;text-decoration: underline">
          点击阅读必读项
        </span>
        <!-- <a
          :href="axios.baseURL + '/File/健康承诺书.doc'"
          style="font-size: 10px; color: red; margin-top: 10px"
          >《《健康承诺书》》下载</a
        > -->
      </div>

      <div style="margin: 60px">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>

    <van-action-sheet v-model:show="orderMinuteShow" title="报名详情">
      <OrderMinute :formData="formData" :cardUpload="cardUpload"/>
    </van-action-sheet>

    <van-dialog
        @confirm="okRead"
        v-model:show="needRead"
        title="报名须知"
        confirm-button-text="确认阅读"
        width="98%"
    >
      <div style="text-align: start;margin: 0 10px">
        <p/>
        <b style="font-size: 13px">尊敬的学员你好，欢迎你报名参加安全培训，请了解以下事项：</b>
        <p style="font-size: 12px">
          1、学员报名缴费后，即在政府培训平台上传学员信息，教学计划等。就近安排参加培训．如接连三个月通知，无故不参加培训，（如因不可抗拒原因或有证明的特殊原因除外）视为自动放弃培训
        </p>
        <p style="font-size: 12px">
          2、本校严格按照国家教学大纲和上级部门要求教学，特种作业证培训（理论和实操）一般在10天左右（具体见课程表），开班前，本校通过电话、微信群、公众号等发布信息、征询意见，如你同意参加当期的培训，要安排好工作及自身事项．务必按时参加培训，不得无故缺席．在学习期间，要服从教学管理（上级有关部门培训期间全程实时监控监管录像）！
        </p>
        <p style="font-size: 12px">
          3、为减轻工学矛盾，本校开展线上和线下培训，报名缴培训费后即开通线上培训系统，发学习资料（学习卡）进行网上平台登录学习等，为此报名前请认真了解有关规定，缴费后本校概不退费，请予理解！
        </p>
        <p style="font-size: 12px">
          4、培训结束，本校即上报考试申请至淮北市应急管理局。淮北市应急管理局安排和通知具体考试时间。本校无权安排和变更！当期培训合格学员务必按市应急管理局通知时间内缴考试费，按时参加当期考试。如个人原因不按时向政府财政缴考试费，不按时参加当期考试，视为自动放弃。本次报名考证程序结束。
        </p>
        <!--        <img src="../assets/read.jpg"/>-->
      </div>

    </van-dialog>

  </div>
</template>

<script>
import {onMounted, reactive, ref, toRefs, watch} from "vue";
import OrderMinute from "./OrderMinute";
import {useRoute, useRouter} from "vue-router";
import axios from "../api/http";
import {Toast} from "vant";

export default {
  name: "Home",
  components: {
    OrderMinute
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const formData = reactive({
      speciesID: 0,
      speciesNameTemp: "",
      projectID: 0,
      projectNameTemp: "",
      courseID: 0,
      courseNameTemp: "",
      chooseType: "新办",
      sex: "男",
      education: "初中",
      dept: "",
      name: "",
      phone: "",
      cardNumber: "",
      cardPositive: "",
      cardNegative: "",
      retrainPositive: "",
      retrainNegative: "",
      poq: "",
      healthBook: "",
      money: 0,
      time: new Date().toISOString(),
      wxCode: "",
      isPay: false
    });

    const educationInfo = reactive({
      educationData: [
        "小学",
        "初中",
        "高中及中专",
        "大专",
        "本科",
        "研究生",
        "其他"
      ],
      educationPickShow: false
    });

    function onEducationSelect(value) {
      formData.education = value;
      educationInfo.educationPickShow = false;
    }

    const speciesIDInfo = reactive({
      speciesName: "",
      speciesIDData: [{id: 1, name: "无网络"}],
      speciesIDPickShow: false
    });

    function onSpeciesIDSelect(value) {
      formData.speciesID = value.id;
      formData.speciesNameTemp = value.name;
      speciesIDInfo.speciesName = value.name;
      speciesIDInfo.speciesIDPickShow = false;
      projectIDInfo.projectName = "";
      courseIDInfo.courseName = "";
    }

    const getAllSpeciesId = () => {
      axios
          .get("/api/RegisterInfo/GetTrainSpecies")
          .then(res => {
            speciesIDInfo.speciesIDData = res.data;
          })
          .catch(e => {
            console.log(e);
            Toast.fail("没有网络连接");
          });
    };

    onMounted(() => {
      const wxCode = route.query.code
      if (wxCode !== undefined) {
        formData.wxCode = wxCode
      } else {
        formData.wxCode = '07147iml2fIx6h48lsll2neqkp347imr'
      }
      getAllSpeciesId();
    });

    const projectIDInfo = reactive({
      projectName: "",
      projectIDData: [{id: 1, name: "无网络"}],
      projectIDPickShow: false
    });

    function onProjectIDSelect(value) {
      formData.projectID = value.id;
      formData.projectNameTemp = value.name;
      projectIDInfo.projectName = value.name;
      projectIDInfo.projectIDPickShow = false;
      courseIDInfo.courseName = "";
    }

    watch(
        () => formData.speciesID,
        newValue => {
          axios
              .get("/api/RegisterInfo/GetTrainProject/id/" + newValue)
              .then(res => {
                projectIDInfo.projectIDData = res.data;
              });
        }
    );

    const courseIDInfo = reactive({
      courseName: "",
      courseIDData: [{id: 1, name: "无网络"}],
      courseIDPickShow: false
    });

    function onCourseIDSelect(value) {
      formData.courseID = value.id;
      formData.courseNameTemp = value.name;
      courseIDInfo.courseName = value.name;
      courseIDInfo.courseIDPickShow = false;
    }

    watch(
        () => formData.projectID,
        newValue => {
          axios
              .get("/api/RegisterInfo/GetTrainCourse/id/" + newValue)
              .then(res => {
                courseIDInfo.courseIDData = res.data;
                if (courseIDInfo.courseIDData.length === 0) {
                  courseIDInfo.courseIDData = [{id: 1, name: "无"}];
                }
              });
        }
    );

    watch(
        () => formData.courseID,
        newValue => {
          console.log(newValue)
          showMoney()
        }
    );

    watch(
        () => formData.chooseType,
        newValue => {
          console.log(newValue)
          showMoney()
        }
    );

    function showMoney() {
      if (formData.chooseType === "新办") {
        formData.money = courseIDInfo.courseIDData.find(
            id => id.id === formData.courseID
        ).money;
      } else {
        formData.money = courseIDInfo.courseIDData.find(
            id => id.id === formData.courseID
        ).moneyOld;
      }
    }

    function onSubmit() {
      if (formData.chooseType === "新办") {
        formData.money = courseIDInfo.courseIDData.find(
            id => id.id === formData.courseID
        ).money;
      } else {
        formData.money = courseIDInfo.courseIDData.find(
            id => id.id === formData.courseID
        ).moneyOld;
      }

      /*      formData.money = courseIDInfo.courseIDData.find(
                id => id.id === formData.courseID
            ).money;
            console.log(formData)
            if (formData.chooseType !== "新办") {
              if (formData.speciesID === 1) {
                formData.money = 300;
              }
              if (formData.speciesID === 3 || formData.speciesID === 5) {
                formData.money = 400;
              }
            }*/

      orderMinuteShow.value = true;
    }

    function onFailed(errorInfo) {
      console.log(errorInfo);
    }

    const cardUpload = reactive({
      cardPositive: [],
      cardNegative: [],
      retrainPositive: [],
      retrainNegative: [],
      poq: [],
      healthBook: []
    });

    function afterRead() {
      // 此时可以自行将文件上传至服务器
    }

    function cardDetection(file) {
      Toast('图片内容不正确,请上传身份证照片');
      console.log(file)
      return false
    }

    const orderMinuteShow = ref(false);

    function cardValidator() {
      if (
          cardUpload.cardPositive.length !== 0 &&
          cardUpload.cardNegative.length !== 0
      ) {
        formData.cardPositive = cardUpload.cardPositive[0].file.name;
        formData.cardNegative = cardUpload.cardNegative[0].file.name;
        return true;
      } else {
        return false;
      }
    }

    function retrainValidator() {
      if (
          cardUpload.retrainPositive.length !== 0 &&
          cardUpload.retrainNegative.length !== 0
      ) {
        formData.retrainPositive = cardUpload.retrainPositive[0].file.name;
        formData.retrainNegative = cardUpload.retrainNegative[0].file.name;
        return true;
      } else {
        return false;
      }
    }

    function poqValidator() {
      if (cardUpload.poq.length !== 0) {
        formData.poq = cardUpload.poq[0].file.name;
        return true;
      } else {
        return false;
      }
    }

    function healthBookValidator() {
      if (cardUpload.healthBook.length !== 0) {
        formData.healthBook = cardUpload.healthBook[0].file.name;
        return true;
      } else {
        return false;
      }
    }

    const onOversize = () => {
      Toast('图片大小不能超过 5M，请上传小于 5M的图片');
    };

    const patternTel = /^1[3-9]\d{9}$/;
    const patternCard = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/;

    const needRead = ref(false)

    function okRead() {
      needRead.value = false
    }

    function readNeed() {
      needRead.value = true
    }

    return {
      router,
      formData,
      ...toRefs(formData),
      ...toRefs(educationInfo),
      onEducationSelect,
      ...toRefs(speciesIDInfo),
      onSpeciesIDSelect,
      ...toRefs(projectIDInfo),
      onProjectIDSelect,
      ...toRefs(courseIDInfo),
      onCourseIDSelect,
      onSubmit,
      onFailed,
      afterRead,
      cardUpload,
      ...toRefs(cardUpload),
      orderMinuteShow,
      cardValidator,
      retrainValidator,
      poqValidator,
      healthBookValidator,
      axios,
      onOversize,
      patternTel,
      patternCard,
      cardDetection,
      needRead,
      okRead,
      readNeed
    };
  }
};
</script>

<style>
.title {
  height: 30px;
  font-weight: bold;
}

.admin-enter {
  display: flex;
  justify-content: flex-end;
}

img {
  width: 100%;
}

.warnTitle {
  margin-top: 10px;
  color: red;
  font-size: 0.8em;
}

.card-custom-upload {
  width: 60px;
  height: 60px;
  background-color: whitesmoke;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-custom-upload-title {
  text-align: center;
  width: 60px;
}

.down-healthBook {
  margin-top: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.picker,
.van-ellipsis {
  white-space: unset;
}
</style>
